// extracted by mini-css-extract-plugin
module.exports = {"main":"TripleDotStyles_main__1bN5s","dot":"TripleDotStyles_dot__AhDUu"};